export default "__VITE_ASSET__DviEzd6a__"